<template>
    <div class="messages">
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Yurt</th>
                                        <th>Ad Soyad</th>
                                        <th>Tarih</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.dorm.name }}</td>
                                        <td>{{ item.name | capitalize }}</td>
                                        <td>{{ item.created_at | dateFormat  }}</td>
                                        <td>
                                            <router-link :to="{ name: 'messages.show', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Göster</span></router-link> / <button class="btn btn-danger btn-xs">Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="10" @paginate="fetchPosts()"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/layouts/Pagination'
    import moment from 'moment'
    export default {
        components: { Pagination, moment },
        data () {
            return {
                tableName: 'Mesajlar Tablosu',
                icon: 'fa fa-envelope',
                tableDesc: '',
                api: 'messages',
                items: [],
                pagination: {
                    'current_page': 1
                }
            }
        },
        mounted () {
            this.fetchPosts()
        },
        methods: {
            fetchPosts() {
                this.$Progress.start()
                this.axios.get(this.api, { params: {
                    page: this.pagination.current_page,
                }}).then(response => {
                    // console.log(response.data)
                    this.pagination = response.data.pagination
                    this.items = response.data.data.data
                    this.$Progress.finish()
                })
            },
        },
        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            },
            dateFormat: function (date) {
                if(!date) return ''
                moment.locale('tr')
                date = moment(date).format('LL')
                return date
            }
        }
    }
</script>

<style scoped>

</style>
